export enum UploadTypes {
  image,
  video,
  PDF,
}

export enum ImageFileType {
  IMAGE = 'image/apng,image/avif,image/tiff,image/icon,image/bmp,image/webp,image/svg+xml,image/png,image/jpeg,image/gif',
}
